import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import AppProfessional from './AppProfessional';
import QRLandingPage from './components/QRLandingPage';
import ShareablePage from './components/ShareablePage';
import BlogPage from './components/BlogPage';
import BlogPost from './components/BlogPost';
import TikTokLanding from './components/TikTokLanding';
import DigitalPortfolio from './components/DigitalPortfolio';
import AdminPanel from './components/AdminPanel';
import ServiceDetailPage from './components/ServiceDetailPage';
import PageTracker from './components/PageTracker';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <PageTracker />
      <Routes>
        <Route path="/" element={<AppProfessional />} />
        <Route path="/qr" element={<QRLandingPage />} />
        <Route path="/share" element={<ShareablePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/tiktok" element={<TikTokLanding />} />
        <Route path="/link" element={<TikTokLanding />} />
        <Route path="/portfolio" element={<DigitalPortfolio />} />
        <Route path="/services/:id" element={<ServiceDetailPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);